import { TabPanel } from "@headlessui/react";
import type { PropsWithChildren } from "react";

type Props = {};

const VideoTabPanel = ({ children }: PropsWithChildren<Props>) => {
	return (
		<TabPanel className="no-scrollbar phablet:h-[calc(100vh-14rem)] phablet:overflow-auto rounded-xl border shadow shadow-slate-100 dark:shadow-slate-900">
			{children}
		</TabPanel>
	);
};

export default VideoTabPanel;
